export interface IHttpError {
  messages: string[];
  name: string;
  error: boolean;
}
